import { getDynamicIslandVariant } from "../dynamicIsland.registry";
import { type DynamicIslandKind } from "../dynamicIsland.types";
import { type DynamicIslandShellMotionConfig } from "./dynamicIslandAnimation.types";
import { getDefaultDynamicIslandShellMotion } from "./dynamicIslandDefaultMotion";

/**
 * Merges global animation config with optional per-variant motion overrides.
 *
 * @param kind Active payload kind.
 * @returns Resolved shell motion config for the presence shell.
 */
export function resolveDynamicIslandMotion( kind: DynamicIslandKind ): DynamicIslandShellMotionConfig {
    const baseline = getDefaultDynamicIslandShellMotion();
    const registration = getDynamicIslandVariant( kind );
    const overrides = registration?.animation?.motionOverrides;

    if ( overrides === undefined ) {
        return baseline;
    }

    return {
        "spring":                overrides.spring ?? baseline.spring,
        "maxWidthPercent":       overrides.maxWidthPercent ?? baseline.maxWidthPercent,
        "shell":                 overrides.shell ?? baseline.shell,
        "rtTextPulseDebounceMs": overrides.rtTextPulseDebounceMs ?? baseline.rtTextPulseDebounceMs,
    };
}

/**
 * Returns the kind-switch priority for asymmetric directional transitions.
 * Higher priority kinds use the incoming (expand) curve when switching.
 *
 * @param kind Payload kind.
 * @returns Priority number (default 0).
 */
export function getDynamicIslandKindSwitchPriority( kind: DynamicIslandKind ): number {
    return getDynamicIslandVariant( kind )?.animation?.kindSwitchPriority ?? 0;
}
